export default {
  notifications: null
}
